var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBriefcaseAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "briefcase-add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.8607 10.1265V9.01367C11.8607 8.39905 11.3646 7.90082 10.7525 7.90082H9.5057V6.78798C9.5057 5.94411 8.82225 5.25781 7.98187 5.25781H4.65716C3.81678 5.25781 3.13333 5.94411 3.13333 6.78798V7.90082H1.88656C1.27448 7.90082 0.77832 8.39905 0.77832 9.01367V10.1265L6.31952 12.3522L11.8607 10.1265ZM3.96451 6.78798C3.96451 6.40432 4.27509 6.09245 4.65716 6.09245H7.98187C8.36394 6.09245 8.67452 6.40432 8.67452 6.78798V7.90082H3.96451V6.78798ZM0.77832 14.5779V11.0255L6.31952 13.2513L11.8607 11.0255V14.5779C11.8607 15.1925 11.3646 15.6908 10.7525 15.6908H1.88656C1.27448 15.6908 0.77832 15.1925 0.77832 14.5779Z",
    fill: "#213A51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.6554 10.0027H18.3663C18.839 10.0027 19.2217 10.3869 19.2217 10.8616C19.2217 11.3364 18.839 11.7206 18.3663 11.7206H16.6554V13.4385C16.6554 13.9133 16.2728 14.2975 15.8 14.2975C15.3273 14.2975 14.9446 13.9133 14.9446 13.4385V11.7206H13.2338C12.761 11.7206 12.3784 11.3364 12.3784 10.8616C12.3784 10.3869 12.761 10.0027 13.2338 10.0027H14.9446V8.28474C14.9446 7.80999 15.3273 7.42578 15.8 7.42578C16.2728 7.42578 16.6554 7.80999 16.6554 8.28474V10.0027Z",
    fill: "#213A51"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseAdd);
export default __webpack_public_path__ + "static/media/briefcase-add.19e8fa3cd2341d3d512efc17740095b6.svg";
export { ForwardRef as ReactComponent };